/**
 * 房间信息设置 样式
 */

import styled from 'styled-components';
import cls from 'classnames';

import { theme } from '@/lib';

const Form = styled.div.attrs((props: { inline?: boolean }) => ({
  className: cls({
    'layout-inline': props.inline,
  }),
}))`
  ._dark & {
    .form {
      padding: 0;
      overflow: visible;
      height: auto;
    }

    .form-item-input {
      background-color: #464d55;
      border-color: #464d55;
    }

    input::placeholder,
    .text-holder {
      color: #8d8f99 !important;
    }

    .form-item-label {
      color: #c3c3c3;
      white-space: nowrap;
      font-size: var(--fs-base);
    }

    .btn-primary-liner {
      background: ${theme.clientColor.primaryLinear};
      border: 0;
      border-radius: 40px;
      &:hover {
        background: ${theme.clientColor.primaryLinear};
      }
    }
  }

  &.layout-inline {
    .form-item {
      display: flex;
    }
    .form-item-label {
      margin: 8px 8px 0 0;
    }
  }

  .form {
    padding: 0 18px;
    margin: 6px 2px;
    height: 360px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .error-tip {
    font-size: var(--fs-md);
    line-height: 14px;
  }

  .form-item {
    position: relative;
    margin-bottom: 14px;
    &-label {
      display: block;
      line-height: 20px;
      margin-bottom: 8px;
      font-size: var(--fs-md);
      font-weight: 500;
      color: #333333;
    }

    &-input {
      box-sizing: border-box;
      width: 380px;
      height: 36px;
      line-height: 36px;
      border-radius: 4px;
      padding: 0 10px;
      border: 1px solid #dddddd;
      font-size: var(--fs-base);
      input {
        width: 100%;
        height: 36px;
        display: block;
      }
    }
  }

  .form-actions {
    text-align: center;
    padding-top: 6px;
    .btn {
      width: 150px;
      height: 40px;
      margin: auto;
      font-size: var(--fs-md);
      font-weight: 500;
      color: #ffffff;
    }
  }
`;

export default {
  Form,
};
